import { getListCodeBase } from '@/api/booking_service/promotion'

async function fnGetCodeBaseList(pCode = null) {
  const res = await getListCodeBase({ pCode: pCode })
  return res.data
}

export { fnGetCodeBaseList }
